import { add, parse, roundToNearestMinutes } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
import { TIMEZONE } from "../constants";
  
  export function getJsDateFromExcel(excelDate: any): Date {
    // JavaScript dates can be constructed by passing milliseconds
    // since the Unix epoch (January 1, 1970) example: new Date(12312512312);
  
    // 1. Subtract number of days between Jan 1, 1900 and Jan 1, 1970, plus 1  (Google "excel leap year bug")
    // 2. Convert to milliseconds.
   
    if (typeof excelDate[0] === "string") {
      return parse(excelDate[0], "M/d/yy h:mma", new Date());
    }

    const excelDateInMilliseconds = (excelDate - (25567 + 2)) * 86400 * 1000
    const utc_date = zonedTimeToUtc(excelDateInMilliseconds, TIMEZONE);
    const zoned_utc_date = add(utc_date, { minutes: utc_date.getTimezoneOffset() })

    return roundToNearestMinutes(zoned_utc_date);
  } 

  